import { render, staticRenderFns } from "./HD.vue?vue&type=template&id=3c2db490&"
import script from "./HD.vue?vue&type=script&lang=ts&"
export * from "./HD.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports